export const pageNames = {
  about: "Rólunk",
  contact: "Kapcsolat",
  home: "Főoldal",
  // todo kozerdeku
};
